import { useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    upsertTagsByVariantId,
} from "../../api/actions/actions";
import { PlaceholderContext } from "../../contexts/Contexts";
import { Dialog } from "../modal/Dialog";
import CodeErrorTemplate from "../../templates/CodeErrorTemplate";
import CollectionList from "../../widgets/CollectionList";
import VariantList from "./VariantList";
import { ReloadSvg, BoxArrowOutSvg, BoxArrowInSvg, ListCheckSvg, ListMinusSvg, DeleteSvg } from "../../icons/Icon";
import { $serializeForm } from "../../main";
import VariantTagInputBar from "./VariantTagInputBar";
import {
    selectAllVariantsEvent,
    selectNoneVariantsEvent,
    applyTagsToAllSelectedVariantsEvent,
    removeTagsFromAllSelectedVariantsEvent,
    clearTagsFromSelectedVariantsEvent,
    enableBatchEditEvent,
    cancelEditEvent
} from "../../events/VariantEditorEvents";
import { fetchAllTagsEvent } from "../../events/TagEvents";
import { fetchAllVariantsEvent } from "../../events/VariantEvents";
import { fetchAllTagGroupsAndTagsEvent } from "../../events/TagGroupEvents";
import { useEventContext } from "../../contexts/EventContextProvider";

const CustomActions = (p) => {

    const onCheckAll = () => {
        selectAllVariantsEvent(p.listRef);
    };
    const onUncheckAll = () => {
        selectNoneVariantsEvent(p.listRef);
    };
    const onApplyToAllSelected = () => {
        applyTagsToAllSelectedVariantsEvent(p.listRef, p.inputRef)
    }
    const onRemoveFromAllSelected = () => {
        removeTagsFromAllSelectedVariantsEvent(p.listRef, p.inputRef)
    }
    const onClearAllSelected = () => {
        clearTagsFromSelectedVariantsEvent(p.listRef);
    }
    const onReload = () => {
        fetchAllVariantsEvent(true);
    };

    return (
        <div className="CollectionList_actions">
            <button className="CollectionList_reload" onClick={onReload}><ReloadSvg /></button>
            <button className="CollectionList_ApplyToAll" onClick={onApplyToAllSelected}><BoxArrowInSvg /></button>
            <button className="CollectionList_RemoveFromAll" onClick={onRemoveFromAllSelected}><BoxArrowOutSvg /></button>
            <button className="CollectionList_RemoveFromAll" onClick={onClearAllSelected}><DeleteSvg /></button>
            <button className="CollectionList_CheckAll" onClick={onCheckAll}><ListCheckSvg /></button>
            <button className="CollectionList_UncheckAll" onClick={onUncheckAll}><ListMinusSvg /></button>
        </div >
    );
}
const VariantTagsEditor = (p) => {

    const dispatch = useDispatch();
    const { state, eventDispatch } = useEventContext();
    const list = useRef(null);
    const inputBar = useRef(null);

    const variants = useSelector((state) => state.base.variants);
    const placeholder = useContext(PlaceholderContext);

    const showError = (error) => {
        placeholder.openModal(<Dialog><CodeErrorTemplate message={error.errors || error.error || error} /></Dialog>, {
            onApprove: (a) => {
                a.actions.close();
            }
        }, {
            heading: `Error: ${(error.status) || ''}`,
            message: ''
        })
    };
    useEffect(() => {
        fetchAllTagsEvent();
        fetchAllVariantsEvent();
        fetchAllTagGroupsAndTagsEvent();
    }, []);

    const onEdit = (e, o) => {
        let [encoded, decoded] = $serializeForm(o);
        decoded['tags'] = decoded['tagsSelected'] || [];
        delete decoded['tagsSelected'];
        console.log('onEdit', decoded, o)
        dispatch(upsertTagsByVariantId(decoded)).unwrap()
            .then((result) => {
                if (result.content > 0) {
                    console.log('onEdit.result', result);
                }
            })
            .catch((error) => {
                console.log("Custom Error:", error, error.error);
            });
    };

    const onMultiSelected = (s) => {
        if ((Object.keys(s).length > 1)) {
            eventDispatch(enableBatchEditEvent(s));
        } else {
            eventDispatch(cancelEditEvent());
        }
    };

    return (
        <div className="page">
            <div className="flex-24">
                <div className="col-24 flex-column">
                    <div className="page-box">
                        <div className='page-box-header'>
                            <h4><span>Variant tag associations</span></h4>
                        </div>
                        <div className='page-box-body'>
                            <VariantTagInputBar ref={inputBar} />
                            <CollectionList
                                ref={list}

                                selectable={true}
                                selectAll={true}
                                unSelectAll={false}
                                onSelect={onMultiSelected}
                                itemsPerPage={10}
                                items={variants}

                                ItemsComponent={VariantList}

                                CustomActionsComponent={(p) => <CustomActions listRef={list} inputRef={inputBar} />}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VariantTagsEditor;